<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createProductoClonar"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mFeedProductsContentModalDuplicate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        v-if="showLoadingState"
        key="loadingState"
        class="m-the-modal-section"
      >
        <AtomLoadingSecondary/>
      </section>
      <section
        v-else
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mFeedProductsContentModalDuplicate.messageDelete.element') }}
          <b>{{ element.nombre }}</b>
          {{ $t('mFeedProductsContentModalDuplicate.messageDelete.options') }}
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mFeedProductsContentModalDuplicate.buttonCancel')"/>
        <AtomButtonPrimary
          v-if="Object.values(element).length"
          :button-primary="buttonPrimary"
        />
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedProductsContentModalDuplicate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedProductsContentModalDuplicate.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      element: {},
      showLoadingState: true
    }
  },

  created () {
    if (this.$modal.element === null) {
      this.readProducto()
    } else {
      this.element = Object.assign({}, this.$modal.element)
      this.showLoadingState = false
    }
  },

  methods: {
    createProductoClonar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('producto', 'createProductoClonar', {}, [this.element.id])
          .then(response => {
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedProductsContentModalDuplicate', 'createProductoClonar', 'success')
            this.$router.push(`/${this.$t('rPaths.product')}/${response.data.id}/${this.$t('mEditionMenu.product.card.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedProductsContentModalDuplicate', 'createProductoClonar', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    readProducto () {
      this.$services.read('producto', 'readProducto', {}, [this.$route.params.id])
        .then(response => {
          this.element = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
